import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=0c20ea3a&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=0c20ea3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20ea3a",
  null
  
)

export default component.exports